export default __webpack_public_path__ + "static/stance-author-5922052aa19aca5aa994867100ebee8c.png";